/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-05 12:32:46                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-11 10:20:44                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * CustomerDisplay: customer display component
*/

/* Imports */
import { Typography } from "@material-tailwind/react";
import { GenericDisplay, GenericDisplayProps } from "../00-generic/GenericDisplay";
/***/

/*
* CustomerDisplay: customer display component
* Used to display a customer entity
*/

export interface CustomerDisplayProps extends GenericDisplayProps {
  customer: EasyTech.Customer;
  hideIndicator?: boolean;
}
//TODO : Class ?
class CustomerDisplay extends GenericDisplay<CustomerDisplayProps> {
  //TODO : Harmoniser les couleurs utiliser celle de tailwind.config.js
  getIndicatorStyle = (() => {
    if (this.props.customer.type) {
      switch (this.props.customer.type) {
        case ("PROSPECT"): return { backgroundColor: "#FDEB12" }; // yellow-chronoflex-500
        case ("ACTIVE"): return { backgroundColor: "#2DBA43" };   // pastel-green-500
        case ("INACTIVE"): return { backgroundColor: "#FF5E5E" }; // red-pastel-500
      }
    }
    return { backgroundColor: "transparent" };
  });

  getData = (() => {
    return this.props.customer?.name || "No customer";
  });

  getTypography(): JSX.Element {
    return (
      <div className="flex items-start gap-2 w-full min-w-0 max-w-[100%]">
        {this.props.customer.type && !this.props.hideIndicator &&
          <span className="w-3 h-3 rounded-full block mt-1.5 shrink-0" style={this.getIndicatorStyle()} />
        }
        <Typography
          variant={this.props.size ? this.props.size : "paragraph"}
          className={`${this.props.className ? this.props.className : ""} block min-w-0 whitespace-normal`}
        >
          {this.getData()}
        </Typography>
      </div>

    );
  }
}

export default CustomerDisplay;
/***/
